/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import useStyles from '../../../assets/styles/components/Modals';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
};

type Props = {
  isOpen: boolean;
  title: string;
  message?: string;
  inputType?: string; // "text", "number", "email"...
  placeholder?: string;
  handleFn: (dataInput: string) => Promise<void> | void;
  btnNamePrimary: string;
  onClose: () => void;
  icon?: any;
};

const ModalInput = ({
  isOpen,
  title,
  message,
  inputType = 'text',
  placeholder = '',
  handleFn,
  btnNamePrimary,
  onClose,
  icon = '',
}: Props): ReactElement => {
  const classeStyle = useStyles();

  const [openModal, setOpenModal] = useState(isOpen);
  const [dataInput, setDataInput] = useState('');

  const closeModal = (): void => {
    setOpenModal(!openModal);
    onClose();
  };

  const handleSetData = (): void => {
    handleFn(dataInput);
    closeModal();
  };

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);
  return (
    <Modal
      style={{ margin: '0px 20px' }}
      open={openModal}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModal}>
        {icon ? (
          <>
            <Grid container item xs={12} justifyContent="center" marginTop={3}>
              {icon}
            </Grid>
            <Grid container item xs={12} justifyContent="center">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                className={classeStyle.titleModal}
                style={{ fontWeight: '500' }}
              >
                {title}
              </Typography>
            </Grid>
          </>
        ) : (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            className={classeStyle.gridModalTop}
          >
            <h4 style={{ margin: 10 }}>{title}</h4>
          </Grid>
        )}

        <Grid padding="0px 15px">
          {message && (
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {message}
            </Typography>
          )}
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <input
              className={classeStyle.inputTextModal}
              type={inputType}
              placeholder={placeholder}
              value={dataInput}
              onChange={(e: any) => setDataInput(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="center" marginBottom="30px">
          <Button
            className={classeStyle.btnModal}
            style={{
              width: '60%',
            }}
            variant="contained"
            onClick={handleSetData}
          >
            {btnNamePrimary}
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalInput;
